import { classes } from 'html-classes';
import { ChangeEvent } from 'react';

import { ProductPropertyFilterChoice } from '../../types/Product/interface';

import Collapsible from '../Collapsible/Collapsible';

interface Props {
  label: string;
  values?: ProductPropertyFilterChoice[];
  currentValues?: string[];
  onChange: (values: string[]) => void;
  className?: string;
  isCollapsed: boolean;
  noCollapsible?: boolean;
}

const ProductTypeListFilter = ({
  label,
  values = [],
  currentValues = [],
  onChange,
  className,
  isCollapsed,
  noCollapsible,
}: Props) => {
  const onChangeValue = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    const isChecked = event.target.checked;

    const newSelected = isChecked
      ? [...currentValues, value]
      : currentValues.filter((s) => s !== value);
    onChange(newSelected);
  };

  const filters = (
    <>
      {values.map((value, idx) => (
        <label className="type control__checkbox" key={`${value.value}_${idx}`}>
          <input
            type="checkbox"
            checked={currentValues.includes(value.value)}
            value={value.value}
            className="type control__checkbox-input"
            onChange={(e) => onChangeValue(e)}
          />
          <span className="type control__checkbox-mark" />
          <span>{value.label}</span>
        </label>
      ))}
    </>
  );

  if (noCollapsible) {
    return filters;
  }

  return (
    <Collapsible
      isCollapsed={!currentValues.length && isCollapsed}
      title={label}
      className={classes(['filter__item', className])}
    >
      {filters}
    </Collapsible>
  );
};

export default ProductTypeListFilter;
